import HTTPService from '../HTTPService'

class ScenarioSteps {
  getAll (companySlug, scenarioSlug) {
    return HTTPService.get(`company/${companySlug}/scenario/${scenarioSlug}/step`)
  }

  addOne (companySlug, scenarioSlug, payload) {
    return HTTPService.post(`company/${companySlug}/scenario/${scenarioSlug}/step`, {
      title: payload.title,
      parent_id: payload.parent_id
    })
  }

  getOne (companySlug, scenarioSlug, stepId) {
    return HTTPService.get(`company/${companySlug}/scenario/${scenarioSlug}/step/${stepId}`)
  }

  updateOne (companySlug, scenarioSlug, stepId, payload) {
    return HTTPService.put(`company/${companySlug}/scenario/${scenarioSlug}/step/${stepId}`, {
      title: payload.title,
      step_code: payload.step_code,
      settings: {
        'callback.trigger_request': payload.settings['callback.trigger_request'],
        'callback.skip_menu': payload.settings['callback.skip_menu'],
        'callback.additional_email_receivers': payload.settings['callback.additional_email_receivers']
      }
    })
  }

  deleteOne (companySlug, scenarioSlug, stepId) {
    return HTTPService.delete(`company/${companySlug}/scenario/${scenarioSlug}/step/${stepId}`)
  }

  sort (companySlug, scenarioSlug, payload) {
    return HTTPService.post(`company/${companySlug}/scenario/${scenarioSlug}/step/sort`, {
      parent_id: payload.parent_id,
      steps: payload.steps // {id: Number, order: Number}[]
    })
  }
}

export default new ScenarioSteps()
